import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import SectionHeading from "./SectionHeading";
import { useLeadModal } from "./LeadModalContext";

const FAQS = [
  {
    q: "Isn't this just a fancy photo booth?",
    a: "Photo booths capture photos. Stori captures guest intelligence and automates marketing. It's the difference between a device and a platform.",
  },
  {
    q: "Will guests actually engage with this?",
    a: "87% capture rate (vs ~8% industry average) proves they do. Guests want to engage when the experience feels personalized and rewarding.",
  },
  {
    q: "What if we don't have playbooks set up?",
    a: "We help you build them during onboarding. Our team works with your marketing department to design playbooks for your key guest segments.",
  },
  {
    q: "How much manual work is required?",
    a: "Zero. Data syncs to your CRM automatically. Playbooks trigger automatically. Follow-up campaigns fire automatically. Your team just monitors performance.",
  },
  {
    q: "What happens to guest data?",
    a: "It's yours. First-party data stored in your CRM. We never sell or share it. GDPR + CCPA compliant by design.",
  },
  {
    q: "Can I use this for both events and permanent installations?",
    a: "Yes. Same platform, different pricing models. Use it once for an event, or install it permanently for recurring revenue.",
  },
  {
    q: "How long does setup take?",
    a: "Software: 10 minutes. Hardware: under 1 minute (with Stori HALO). Playbooks: 1–2 hours with our team during onboarding.",
  },
];

export default function FAQ() {
  const { openModal } = useLeadModal();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 lg:py-32 border-b border-stori-border bg-stori-bg"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <SectionHeading
            eyebrow="FAQ"
            title="Answers to the questions every team asks."
            lead="Don't see yours? Book a 20-minute demo and we'll walk through it live."
          />
          <button
            type="button"
            onClick={() => openModal("demo_request")}
            data-testid="faq-cta-demo"
            className="mt-8 inline-flex items-center gap-2 bg-stori-cyan text-black font-medium px-5 py-3 rounded-md hover:bg-stori-cyanHover transition-colors"
          >
            Book a demo
          </button>
        </div>

        <div className="lg:col-span-7">
          <Accordion
            type="single"
            collapsible
            className="border-t border-stori-border"
            data-testid="faq-accordion"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-stori-border"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-heading text-lg lg:text-xl text-white hover:text-stori-cyan hover:no-underline transition-colors"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-stori-muted leading-relaxed text-base pb-6 max-w-2xl"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
